var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _g, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _g2, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstallation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 410,
    height: 377,
    viewBox: "0 0 422 410",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_373_33698)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M409.295 143.583C405.631 95.1711 373.035 54.403 332.582 30.0071C293.512 6.45526 246.603 -3.8133 201.271 1.26996C138.51 8.30118 54.8956 48.5127 59.2368 122.572C60.0252 135.967 63.7913 149.352 61.8248 162.626C58.2813 186.568 37.6144 203.571 23.8395 223.468C9.27613 244.496 2.00373 270.46 3.50644 295.988C5.19468 324.586 20.0363 354.352 46.6121 365.038C73.2807 375.752 103.344 365.103 132.063 366.17C178.582 367.895 218.701 400.111 264.561 408.116C298.363 414.025 334.391 405.881 362.358 386.011C375.438 376.717 386.996 364.639 393.044 349.779C408.266 312.369 385.4 269.792 391.42 229.85C395.567 202.383 410.288 178.396 409.611 149.965C409.555 147.822 409.453 145.698 409.295 143.583Z",
    fill: "#DFFF02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M405.982 143.583C402.318 95.1711 369.722 54.403 329.27 30.0071C290.199 6.45525 243.29 -3.8133 197.958 1.26996C135.197 8.30118 51.5922 48.5127 55.9241 122.572C56.7125 135.967 60.4786 149.352 58.5121 162.626C54.9686 186.568 34.3017 203.571 20.5268 223.468C5.97271 244.487 -1.30896 270.451 0.193755 295.978C1.88199 324.576 16.7236 354.343 43.2994 365.029C69.968 375.743 100.032 365.094 128.75 366.161C175.269 367.886 215.388 400.102 261.249 408.107C295.051 414.016 331.079 405.871 359.046 386.002C372.125 376.707 383.683 364.63 389.731 349.77C404.953 312.36 382.087 269.783 388.108 229.84C392.254 202.374 406.975 178.386 406.298 149.955C406.242 147.812 406.14 145.688 405.982 143.573V143.583Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M407.488 405.844H419.157",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44531 405.844H400.873",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6133 242.309L29.5162 365.902",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.443 342.247L21.5898 336.078",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3695 337.925C23.3695 337.925 23.5365 335.189 21.0412 332.962C19.5385 331.617 11.6446 328.297 10.8932 331.079C10.077 334.103 18.1656 340.049 23.3695 337.925Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3705 337.925L15.8477 333.24",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9079 356.309L23.0547 350.131",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8343 351.978C24.8343 351.978 25.0013 349.241 22.5061 347.015C21.0033 345.67 13.1094 342.349 12.3581 345.132C11.5418 348.156 19.6305 354.102 24.8343 351.978Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8354 351.977L17.3125 347.293",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.861 307.953L18.0078 301.775",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7875 303.622C19.7875 303.622 19.9544 300.886 17.4592 298.66C15.9565 297.315 8.06257 293.994 7.31122 296.777C6.49493 299.801 14.5836 305.747 19.7875 303.622Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7885 303.622L12.2656 298.938",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3258 322.008L19.4727 315.83",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2523 317.685C21.2523 317.685 21.4193 314.948 18.924 312.722C17.4213 311.377 9.52742 308.056 8.77606 310.839C7.95977 313.863 16.0485 319.809 21.2523 317.685Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2533 317.684L13.7305 313",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4782 285.117L15.625 278.939",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4046 280.794C17.4046 280.794 17.5716 278.058 15.0764 275.832C13.5737 274.486 5.67976 271.166 4.9284 273.948C4.11211 276.972 12.2008 282.918 17.4046 280.794Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4057 280.794L9.88281 276.109",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0836 262.188L13.2305 256.01",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0101 257.864C15.0101 257.864 15.1771 255.128 12.6818 252.902C11.1791 251.557 3.28523 248.236 2.53387 251.019C1.71758 254.043 9.80627 259.989 15.0101 257.864Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0111 257.864L7.48828 253.17",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.457 333.935L30.9002 326.682",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5473 328.862C29.5473 328.862 28.8238 326.227 30.7995 323.528C31.9869 321.905 39.0367 317.025 40.3446 319.595C41.7638 322.387 35.0851 329.873 29.5473 328.862Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5469 328.861L36.3184 322.387",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5898 296.944L27.0423 289.699",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6879 291.869C25.6879 291.869 24.9644 289.235 26.9402 286.536C28.1275 284.912 35.1773 280.033 36.4852 282.603C37.9044 285.395 31.2257 292.88 25.6879 291.869Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6875 291.87L32.459 285.404",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8984 280.691L25.3416 273.438",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9887 275.617C23.9887 275.617 23.2652 272.983 25.241 270.284C26.4283 268.66 33.4781 263.781 34.786 266.351C36.2052 269.143 29.5265 276.629 23.9887 275.617Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9883 275.617L30.7598 269.143",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4062 256.861L22.8587 249.607",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5043 251.787C21.5043 251.787 20.7808 249.153 22.7566 246.454C23.9439 244.83 30.9937 239.951 32.3016 242.521C33.7208 245.313 27.0421 252.798 21.5043 251.787Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5039 251.787L28.2754 245.312",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5043 241.621C16.5043 241.621 15.7808 238.987 17.7566 236.288C18.9439 234.664 25.9937 229.785 27.3016 232.355C28.7208 235.147 22.0421 242.632 16.5043 241.621Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5039 241.621L23.2754 235.146",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9016 241.9C16.9016 241.9 14.2023 242.345 11.7256 240.091C10.2414 238.736 6.12287 231.223 8.81291 230.184C11.7349 229.062 18.4785 236.492 16.9016 241.89V241.9Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9005 241.9L11.168 234.488",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6373 259.33L37.8086 382.933",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6478 359.361L36.1953 352.107",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5489 354.287C37.5489 354.287 38.2725 351.644 36.2967 348.954C35.1001 347.33 28.0596 342.451 26.7517 345.021C25.3324 347.813 32.0204 355.298 37.5489 354.287Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5474 354.288L31.1562 348.156",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M44.201 325.059L39.7578 317.805",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1114 319.985C41.1114 319.985 41.835 317.35 39.8592 314.651C38.6626 313.028 31.6221 308.148 30.3142 310.718C28.8949 313.51 35.5829 320.986 41.1114 319.985Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1099 319.985L34.7188 313.854",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7416 339.112L38.2891 331.867",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6544 334.037C39.6544 334.037 40.3779 331.394 38.4022 328.704C37.2055 327.08 30.165 322.201 28.8571 324.771C27.4379 327.563 34.1259 335.039 39.6544 334.037Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6544 334.038L33.2539 327.906",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5736 302.221L42.1211 294.977",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4747 297.147C43.4747 297.147 44.1983 294.512 42.2225 291.813C41.0259 290.19 33.9854 285.311 32.6774 287.88C31.2582 290.672 37.9462 298.149 43.4747 297.147Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4732 297.147L37.082 291.016",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M48.951 279.291L44.5078 272.037",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8614 274.217C45.8614 274.217 46.585 271.583 44.6092 268.883C43.4126 267.26 36.3721 262.381 35.0642 264.95C33.6449 267.742 40.3329 275.219 45.8614 274.217Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8599 274.217L39.4688 268.086",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3984 351.014L47.2423 344.836",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4633 346.691C45.4633 346.691 45.2963 343.954 47.7915 341.728C49.2943 340.383 57.1882 337.062 57.9395 339.845C58.7558 342.869 50.6764 348.815 45.4633 346.691Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4609 346.69L53.4198 341.746",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2305 314.031L51.0744 307.844",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3031 309.698C49.3031 309.698 49.1361 306.962 51.6314 304.736C53.1341 303.391 61.028 300.07 61.7793 302.853C62.5956 305.877 54.5162 311.823 49.3031 309.698Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3008 309.699L57.2596 304.764",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M46.918 297.77L52.7619 291.592",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9906 293.447C50.9906 293.447 50.8236 290.71 53.3189 288.484C54.8216 287.139 62.7155 283.818 63.4668 286.601C64.2831 289.625 56.2037 295.571 50.9906 293.447Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9883 293.446L58.9471 288.502",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3945 273.94L55.2384 267.762",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4633 269.607C53.4633 269.607 53.2963 266.87 55.7915 264.644C57.2943 263.299 65.1881 259.978 65.9395 262.761C66.7558 265.785 58.6764 271.731 53.4633 269.607Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4648 269.607L61.4237 264.672",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6742 258.634C50.6742 258.634 50.5072 255.898 53.0025 253.671C54.5052 252.326 62.3991 249.006 63.1504 251.788C63.9667 254.812 55.8873 260.758 50.6742 258.634Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6719 258.634L58.6307 253.699",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9976 258.986C50.9976 258.986 48.2612 258.865 46.304 256.157C45.1259 254.524 42.6492 246.324 45.4877 245.87C48.5859 245.378 53.6506 254.033 50.9884 258.995L50.9976 258.986Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9994 258.987L46.918 250.555",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9375 208.998V365.299",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0666 341.802L30.8906 335.049",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4671 337.071C32.4671 337.071 32.9216 334.372 30.6676 331.895C29.3133 330.401 21.7997 326.283 20.77 328.973C19.6476 331.895 27.0685 338.648 32.4671 337.071Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4668 337.071L25.4727 331.635",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0666 312.425L30.8906 305.682",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4671 307.704C32.4671 307.704 32.9216 305.004 30.6676 302.528C29.3133 301.034 21.7997 296.916 20.77 299.606C19.6476 302.528 27.0685 309.281 32.4671 307.704Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4668 307.703L25.4727 302.258",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0666 277.937L30.8906 271.193",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4671 273.215C32.4671 273.215 32.9216 270.516 30.6676 268.039C29.3133 266.546 21.7997 262.427 20.77 265.117C19.6476 268.039 27.0685 274.792 32.4671 273.215Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4668 273.215L25.4727 267.77",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0666 254.987L30.8906 248.234",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4671 250.256C32.4671 250.256 32.9216 247.557 30.6676 245.08C29.3133 243.587 21.7997 239.468 20.77 242.158C19.6476 245.08 27.0685 251.833 32.4671 250.256Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4668 250.256L25.4727 244.82",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0666 231.927L30.8906 225.174",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4671 227.196C32.4671 227.196 32.9216 224.497 30.6676 222.02C29.3133 220.526 21.7997 216.408 20.77 219.098C19.6476 222.02 27.0685 228.773 32.4671 227.196Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4668 227.195L25.4727 221.76",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9453 350.772L41.1213 344.02",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5454 346.042C39.5454 346.042 39.0908 343.342 41.3449 340.866C42.6992 339.372 50.2128 335.254 51.2424 337.944C52.3648 340.866 44.944 347.619 39.5454 346.042Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M39.543 346.041L46.9545 340.309",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9453 304.058L41.1213 297.305",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5454 299.327C39.5454 299.327 39.0908 296.627 41.3449 294.151C42.6992 292.657 50.2128 288.539 51.2424 291.229C52.3648 294.151 44.944 300.904 39.5454 299.327Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M39.543 299.326L46.9545 293.594",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9453 280.997L41.1213 274.244",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5454 276.266C39.5454 276.266 39.0908 273.567 41.3449 271.09C42.6992 269.597 50.2128 265.478 51.2424 268.168C52.3648 271.09 44.944 277.843 39.5454 276.266Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M39.543 276.266L46.9545 270.533",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9453 250.517L41.1213 243.773",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5454 245.796C39.5454 245.796 39.0908 243.096 41.3449 240.619C42.6992 239.126 50.2128 235.008 51.2424 237.698C52.3648 240.62 44.944 247.372 39.5454 245.796Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M39.543 245.795L46.9545 240.062",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9453 226.556L41.1213 219.812",
    stroke: "#212121",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5454 221.835C39.5454 221.835 39.0908 219.135 41.3449 216.659C42.6992 215.165 50.2128 211.047 51.2424 213.737C52.3648 216.659 44.944 223.412 39.5454 221.835Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M39.543 221.836L46.9545 216.104",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6391 211.206C35.6391 211.206 35.1846 208.506 37.4387 206.03C38.793 204.536 46.3065 200.418 47.3362 203.108C48.4586 206.03 41.0377 212.783 35.6391 211.206Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6406 211.205L43.0429 205.473",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0004 211.53C36.0004 211.53 33.264 211.697 31.0471 209.201C29.7113 207.699 26.3905 199.795 29.1733 199.053C32.1973 198.237 38.1339 206.335 36.0004 211.539V211.53Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9998 211.529L31.0742 203.561",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M42.367 405.844H25.8186L23.75 364.037H44.4448L42.367 405.844Z",
    fill: "#212121",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M135.698 50.4629C134.372 52.6799 133.416 55.1473 132.906 57.7724C131.913 57.6425 130.912 57.5683 129.882 57.5683C117.304 57.5683 107.109 67.7627 107.109 80.3409C107.109 84.3111 108.12 88.04 109.911 91.2866",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M187.636 70.786C184.77 68.6804 181.245 67.4096 177.433 67.3354C177.822 65.6564 178.036 63.9125 178.036 62.1222C178.036 49.544 167.841 39.3496 155.263 39.3496C148.093 39.3496 141.702 42.6612 137.527 47.8464",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M112.016 94.4493C115.086 98.3267 119.39 101.184 124.334 102.427H181.948C189.452 100.293 194.943 93.4011 194.943 85.2197C194.943 81.2217 193.626 77.5206 191.409 74.543",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M226.408 61.4551C220.351 65.5458 216.371 72.475 216.371 80.3411C216.371 90.9992 223.699 99.9506 233.597 102.427H291.21C293.269 101.843 295.18 100.897 296.859 99.663",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M285.434 53.1152C281.946 45.0173 273.895 39.3496 264.517 39.3496C253.432 39.3496 244.193 47.2806 242.161 57.7718C241.169 57.6419 240.167 57.5677 239.138 57.5677C236.271 57.5677 233.535 58.0964 231.012 59.0611",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M299.914 96.8336C302.586 93.7076 304.2 89.654 304.2 85.22C304.2 75.4617 296.389 67.5307 286.677 67.3359C287.067 65.6569 287.28 63.913 287.28 62.1227C287.28 60.2026 287.039 58.3474 286.594 56.5664",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M151.078 196.234V131.033",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M198.387 80.2578H207.663",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M259.609 104.375V126.146",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M194.798 194.055H135.691V253.161H194.798V194.055Z",
    fill: "white",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M192.051 196.801H138.445V250.407H192.051V196.801Z",
    fill: "#212121",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M179.615 214.852L167.111 227.922L157.371 225.195C156.397 224.926 155.358 225.111 154.542 225.705L138.43 237.393V250.426H192.036V222.857L184.365 214.861C183.066 213.507 180.895 213.507 179.597 214.861L179.615 214.852Z",
    fill: "white",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M164.583 213.785C166.002 210.33 164.351 206.38 160.896 204.961C157.441 203.543 153.49 205.194 152.072 208.649C150.654 212.104 152.305 216.054 155.759 217.472C159.214 218.891 163.165 217.24 164.583 213.785Z",
    fill: "white",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M154.085 215.872H100.117V144.289H130.227L154.085 168.147V215.872Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_373_33698",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 144,
    width: 55,
    height: 72
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M154.085 215.872H100.117V144.289H130.227L154.085 168.147V215.872Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_373_33698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.104 168.305V177.469C151.655 170.902 130.246 168.305 130.246 168.305H154.104Z",
    fill: "#DFFF02"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M154.104 168.305V177.469C151.655 170.902 130.246 168.305 130.246 168.305H154.104Z",
    fill: "white"
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M154.085 215.872H100.117V144.289H130.227L154.085 168.147V215.872Z",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M154.084 168.147H130.227V144.289L154.084 168.147Z",
    fill: "white",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M113.742 177.145H140.457",
    stroke: "#212121",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M113.742 184.5H140.457",
    stroke: "#212121",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M113.742 191.848H140.457",
    stroke: "#212121",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M131.711 199.861H98.2891V217.671H131.711V199.861Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M108.345 211.697V212.894H107.148V211.697H108.345Z",
    fill: "#212121"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M112.929 206.948V207.978C112.929 209.239 112.316 209.935 111.073 209.935H110.489V212.903H109.246V205H111.073C112.316 205 112.929 205.686 112.929 206.957V206.948ZM110.489 206.122V208.803H111.073C111.472 208.803 111.686 208.627 111.686 208.061V206.874C111.686 206.308 111.472 206.132 111.073 206.132H110.489V206.122Z",
    fill: "#212121"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M113.504 204.99H115.47C116.713 204.99 117.326 205.677 117.326 206.947V210.945C117.326 212.207 116.713 212.903 115.47 212.903H113.504V205V204.99ZM114.747 206.122V211.771H115.443C115.841 211.771 116.073 211.567 116.073 211.001V206.892C116.073 206.326 115.832 206.122 115.443 206.122H114.747Z",
    fill: "#212121"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M119.356 208.506H120.961V209.638H119.356V212.903H118.113V205H121.397V206.132H119.356V208.516V208.506Z",
    fill: "#212121"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M282.417 74.8203H258.707V98.5298H282.417V74.8203Z",
    fill: "white",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M281.324 75.9238H259.812V97.4349H281.324V75.9238Z",
    fill: "#212121",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M276.333 83.1585L271.315 88.3995L267.41 87.3049C267.02 87.1936 266.603 87.2678 266.278 87.509L259.812 92.1934V97.425H281.324V86.368L278.244 83.1585C277.724 82.6112 276.853 82.6112 276.333 83.1585Z",
    fill: "white",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M270.283 82.7298C270.853 81.3413 270.19 79.7535 268.801 79.1834C267.413 78.6133 265.825 79.2769 265.255 80.6655C264.685 82.054 265.348 83.6418 266.737 84.2119C268.125 84.7819 269.713 84.1184 270.283 82.7298Z",
    fill: "white",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M266.082 83.5779H244.441V54.8594H256.519L266.082 64.4322V83.5779Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_373_33698",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 244,
    y: 54,
    width: 23,
    height: 30
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M266.082 83.5779H244.441V54.8594H256.519L266.082 64.4322V83.5779Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_373_33698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.092 64.498V68.1713C265.109 65.537 256.52 64.498 256.52 64.498H266.092Z",
    fill: "#DFFF02"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M266.092 64.498V68.1713C265.109 65.537 256.52 64.498 256.52 64.498H266.092Z",
    fill: "white"
  }))), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M266.082 83.5779H244.441V54.8594H256.519L266.082 64.4322V83.5779Z",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M266.083 64.4322H256.52V54.8594L266.083 64.4322Z",
    fill: "white",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M249.906 68.041H260.62",
    stroke: "#212121",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M249.906 70.9902H260.62",
    stroke: "#212121",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M249.906 73.9414H260.62",
    stroke: "#212121",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M257.112 77.1504H243.699V84.2929H257.112V77.1504Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M247.732 81.8984V82.3808H247.25V81.8984H247.732Z",
    fill: "#212121"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M249.576 79.9974V80.4056C249.576 80.9158 249.335 81.1941 248.834 81.1941H248.602V82.3814H248.102V79.209H248.834C249.335 79.209 249.576 79.4873 249.576 79.9974ZM248.593 79.6635V80.7395H248.825C248.983 80.7395 249.066 80.6653 249.066 80.4427V79.9696C249.066 79.747 248.983 79.6728 248.825 79.6728H248.593V79.6635Z",
    fill: "#212121"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M249.801 79.209H250.589C251.09 79.209 251.331 79.4873 251.331 79.9974V81.6022C251.331 82.1124 251.09 82.3907 250.589 82.3907H249.801V79.2183V79.209ZM250.302 79.6635V81.9269H250.58C250.738 81.9269 250.83 81.8434 250.83 81.6207V79.9696C250.83 79.747 250.738 79.6635 250.58 79.6635H250.302Z",
    fill: "#212121"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M252.149 80.6189H252.789V81.0735H252.149V82.3814H251.648V79.209H252.966V79.6635H252.149V80.6189Z",
    fill: "#212121"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M216.297 151.58H382.44C388.061 151.58 392.625 156.144 392.625 161.765V311.666H206.121V161.765C206.121 156.144 210.685 151.58 216.306 151.58H216.297Z",
    fill: "white",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M382.449 151.58H258.734V180.354H392.634V161.755C392.634 156.134 388.079 151.57 382.449 151.57V151.58Z",
    fill: "#212121",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M382.449 151.58H216.306C210.685 151.58 206.121 156.135 206.121 161.765V169.158H392.625V161.765C392.625 156.144 388.07 151.58 382.44 151.58H382.449Z",
    fill: "#212121",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M367.56 163.452C369.097 163.452 370.343 162.206 370.343 160.67C370.343 159.133 369.097 157.887 367.56 157.887C366.023 157.887 364.777 159.133 364.777 160.67C364.777 162.206 366.023 163.452 367.56 163.452Z",
    fill: "white",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M376.224 163.452C377.761 163.452 379.007 162.206 379.007 160.67C379.007 159.133 377.761 157.887 376.224 157.887C374.687 157.887 373.441 159.133 373.441 160.67C373.441 162.206 374.687 163.452 376.224 163.452Z",
    fill: "white",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M384.88 163.452C386.417 163.452 387.663 162.206 387.663 160.67C387.663 159.133 386.417 157.887 384.88 157.887C383.344 157.887 382.098 159.133 382.098 160.67C382.098 162.206 383.344 163.452 384.88 163.452Z",
    fill: "white",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M166.608 287.474L162.841 282.104L146.664 305.136H154.614V321.582H161.125",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M164.578 321.581H171.062V305.135H179.012L167.917 289.338",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M112.009 254.47L101.917 240.102L91.8242 254.47H96.7869V264.739H107.046V254.47H112.009Z",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M345.154 49.0799L350.831 40.9912H345.868V30.7227H335.599V40.9912H330.637L340.738 55.3598L343.196 51.8534",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M414.575 262.892L421.012 253.718H416.059V243.449H411.922",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M408.731 243.449H405.791V253.718H400.828L410.92 268.086L412.711 265.535",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4988 85.9711H83.9773V75.7118H88.9307L78.8384 61.334L68.7461 75.7118H73.7088V85.9711H77.8459",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M167.213 95.7946L151.035 72.7715L134.867 95.7946H142.817V112.241H159.263V95.7946H167.213Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M243.699 148.9L259.877 171.932L276.045 148.9H268.095V132.453H251.649V148.9H243.699Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_373_33698)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.999 220.666V235.833C298.999 236.761 299.367 237.651 300.024 238.308C300.68 238.964 301.57 239.333 302.499 239.333H317.665V262.666C317.665 263.904 317.174 265.091 316.299 265.966C315.423 266.841 314.236 267.333 312.999 267.333H284.999C283.761 267.333 282.574 266.841 281.699 265.966C280.824 265.091 280.332 263.904 280.332 262.666V225.333C280.332 224.095 280.824 222.908 281.699 222.033C282.574 221.158 283.761 220.666 284.999 220.666H298.999ZM302.711 247.866L296.936 253.641L295.286 251.991C294.846 251.566 294.257 251.331 293.645 251.336C293.033 251.341 292.448 251.587 292.015 252.019C291.583 252.452 291.337 253.037 291.332 253.649C291.327 254.261 291.562 254.85 291.987 255.29L295.121 258.426C295.359 258.665 295.642 258.854 295.954 258.983C296.265 259.112 296.599 259.179 296.936 259.179C297.273 259.179 297.607 259.112 297.919 258.983C298.23 258.854 298.513 258.665 298.751 258.426L306.01 251.165C306.233 250.95 306.411 250.692 306.533 250.408C306.656 250.123 306.72 249.817 306.723 249.507C306.725 249.197 306.666 248.89 306.549 248.603C306.432 248.316 306.258 248.056 306.039 247.837C305.82 247.618 305.56 247.444 305.273 247.327C304.986 247.21 304.679 247.151 304.369 247.153C304.059 247.156 303.753 247.22 303.468 247.343C303.184 247.465 302.926 247.643 302.711 247.866ZM303.665 220.766C304.549 220.954 305.36 221.394 305.999 222.033L316.298 232.333C316.937 232.971 317.378 233.782 317.565 234.666H303.665V220.766Z",
    fill: "#212121"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_373_33698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 421.474,
    height: 410,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_373_33698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(271 216)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallation);
export default __webpack_public_path__ + "static/media/installation.1c6a51475df47a4788d1c2257faab60b.svg";
export { ForwardRef as ReactComponent };